import React from "react";
// import useEmblaCarousel from "embla-carousel-react";
// import Autoplay from "embla-carousel-autoplay";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export const ContactForm = () => {
  return (
    <div className="relative flex items-center">
      <div className="absolute top-0 right-0 w-[95%] md:w-[560px] h-[350px]  bg-[#07775D] rounded-[25px] shadow-lg"></div>

      <div className="relative z-10 md:mt-4 bg-white w-[75%] md:w-[550px] h-[350px] p-12 rounded-[25px] shadow-xl">
        <h2 className="text-center text-2xl font-bold">Spotted Fraud?</h2>
        <p className="text-center text-gray-600 text-base mt-2">
        The Uniswitch support team is here to help if you suspect fraud or notice any suspicious activity.
         Reach out to us immediately at our email address below.
        </p>

        <div className="flex justify-center items-center text-green-600 my-6">
            <span>
            -----------------------------------------------------------
            </span>
        </div>

        <p className="text-center text-black font-bold text-base mt-2">
        Email address
        </p>
        <p className="text-center text-gray-600 text-base mt-2">
        frauddesk@uniswitchng.com
        </p>
      </div>
    </div>
  );
};

export const HeroSection = () => {
  // const [emblaRef] = useEmblaCarousel({ loop: false }, [Autoplay()]);
  return (
    <section
      id="about"
      className="container mx-auto md:px-[5em] flex flex-col-reverse justify-center md:flex-row mt-32 py-16 animate-slidein"
    >
      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-2xl md:text-[3rem] font-bold mb-4 leading-normal">
        Think You’ve Spotted<br></br> Fraud? We’re Here to<br></br> Help!
        </h2>
        <p className="text-gray-800 text-lg">
        If you see any unusual activity on your account, let us know immediately.
        Our team is ready to help you secure your account and stay protected.
        </p>

      </div>
      <div className="w-full md:w-[35em] p-2 flex md:justify-end">
      <ContactForm />
      </div>
    </section>
  );
};


export const FraudScreen = () => (
  <div className="font-sans">
    <Navbar />
    <HeroSection />
    <Footer />
  </div>
);

export default FraudScreen;
